import { PRICING_PAGE } from "@/lib/constants";
import { ShieldCheck } from "lucide-react";

export default function Guarantee() {
  const { guarantee } = PRICING_PAGE;

  return (
    <section
      data-testid="guarantee-section"
      className="bg-white py-12 md:py-20"
      aria-label="Guarantee"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-2xl">
        <div
          data-testid="guarantee-card"
          className="bg-[#D8FFB8]/15 border-2 border-[#20611B]/15 rounded-xl p-8 md:p-10 text-center"
        >
          <div className="flex justify-center mb-4">
            <ShieldCheck className="h-12 w-12 text-[#20611B]" />
          </div>
          <h3
            className="font-heading text-2xl md:text-3xl font-bold text-[#1A1A1A] tracking-tight mb-4"
            data-testid="guarantee-heading"
          >
            {guarantee.heading}
          </h3>
          <p className="text-[#6B7280] text-base leading-relaxed max-w-lg mx-auto">
            {guarantee.body}
          </p>
        </div>
      </div>
    </section>
  );
}
